module.exports = __webpack_public_path__ + "static/media/update.047c23d4.svg";